<template>
    <div class="request_for_demo_section unauthorized_req_demo_main">
        <div class="request_for_demo_section_inner">
            <div class="request_for_demo_section_center">
                <div class="request_for_demo_section_modal">
                    <div class="request_for_demo_section_header">
                        <h4>Register for a demo</h4>
                        <p class="request_for_demo_blurb">Discover everything our platform has to offer and its full
                            functionality
                            by receiving a personalised tour.</p>
                    </div>
                    <template v-if="demoReqFormConfirmationState">
                        <div class="request_for_demo_section_body" style="min-height:390px;">
                            <div class="request_for_demo_confirmation_box">
                                <h5>Confirmation Message</h5>
                                <h4>Your request has been successfully submitted. Our Admin will send you a confirmation
                                    email
                                    shortly.<span style="display:block;padding-top:20px;">Thank you for choosing
                                        Lymphomap!</span></h4>
                                <button class="btn btn-success" @click="demoReqFormConfirmationMethod">OK</button>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="request_for_demo_section_body" v-if="demoReqFirstScreenState">
                            <i class="fa fa-times-circle-o" aria-hidden="true" @click="backToFirstScreenMethod"></i>
                            <i class="fa fa-times-circle-o mbl_cross" aria-hidden="true"
                                @click="scrollBackOfDemoReqMethod"></i>
                            <form @submit.prevent="otpGenerateForDemoReqMethod">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group custom_radio_btn_for_demo">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-auto">
                                                    <input type="radio" id="company" value="company" name="select"
                                                        v-model="select_option" hidden>
                                                    <label for="company"><span></span> Hospital/Institution</label>
                                                </div>
                                                <div class="col-sm-12 col-md mt-3 mt-md-0">
                                                    <input type="radio" id="individual" value="individual" name="select"
                                                        v-model="select_option" hidden>
                                                    <label for="individual"><span></span> Individual</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>First Name <span class="star_required">*</span></label>
                                            <input type="text" class="form-control" v-validate="'required'"
                                                v-model="first_name" name="first_name"
                                                v-bind:class="{ 'is-invalid': errors.has('first_name') }"
                                                data-vv-as="first name">
                                            <small class="invalid-feedback" v-if="errors.has('first_name')">{{
                                                errors.first('first_name')
                                            }}</small>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Last Name <span class="star_required">*</span></label>
                                            <input type="text" class="form-control" v-validate="'required'"
                                                v-model="last_name" name="last_name"
                                                v-bind:class="{ 'is-invalid': errors.has('last_name') }"
                                                data-vv-as="last name">
                                            <small class="invalid-feedback" v-if="errors.has('last_name')">{{
                                                errors.first('last_name')
                                            }}</small>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Email <span class="star_required">*</span></label>
                                            <input type="email" class="form-control" v-validate="'required'"
                                                v-model="email" name="email"
                                                v-bind:class="{ 'is-invalid': errors.has('email') }" data-vv-as="email">
                                            <small class="invalid-feedback" v-if="errors.has('email')">{{
                                                errors.first('email') }}</small>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Phone Number</label>
                                            <input type="number" class="form-control" v-model="phone_no">
                                        </div>
                                    </div>
                                    <div class="col-sm-4" v-if="select_option == 'company'">
                                        <div class="form-group">
                                            <label>Hospital/Institution Name <span
                                                    class="star_required">*</span></label>
                                            <input type="text" class="form-control" v-validate="'required'"
                                                v-model="company_name" name="company_name"
                                                v-bind:class="{ 'is-invalid': errors.has('company_name') }"
                                                data-vv-as="company name">
                                            <small class="invalid-feedback" v-if="errors.has('company_name')">{{
                                                errors.first('company_name')
                                            }}</small>
                                        </div>
                                    </div>
                                    <div class="col-sm-4" v-if="select_option == 'company'">
                                        <div class="form-group">
                                            <label>Number of Attendees <span class="star_required">*</span></label>
                                            <input type="number" max="5" class="form-control" v-validate="'required'"
                                                v-model="num_of_attendees" name="num_of_attendees"
                                                v-bind:class="{ 'is-invalid': errors.has('num_of_attendees') }"
                                                data-vv-as="number of attendees">
                                            <small class="invalid-feedback" v-if="errors.has('num_of_attendees')">The
                                                number of attendees has a
                                                max capacity of 5</small>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 signup_fields_multiselect">
                                        <div class="form-group multiselect_dropdown_ui"
                                            v-click-outside="enabledScrollContryFieldMethod">
                                            <label>Country <span class="star_required">*</span></label>
                                            <div @click="disabledScrollContryFieldMethod">
                                                <multiselect v-model="country" label="name" track-by="value"
                                                    :options="countryList" :option-height="104" :multiple="false"
                                                    v-validate="'required'"
                                                    v-bind:class="{ 'is-invalid': errors.has('country') }"
                                                    name="country" data-vv-as="country" placeholder=""
                                                    :show-labels="false">
                                                    <span slot="noResult">No elements found.</span>
                                                </multiselect>
                                            </div>
                                            <small class="invalid-feedback d-block" v-if="errors.has('country')">{{
                                                errors.first('country') }}</small>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>City <span class="star_required">*</span></label>
                                            <input type="text" class="form-control" v-validate="'required'"
                                                v-model="city" name="city"
                                                v-bind:class="{ 'is-invalid': errors.has('city') }" data-vv-as="city">
                                            <small class="invalid-feedback" v-if="errors.has('city')">{{
                                                errors.first('city') }}</small>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group custom_datetime_picker"
                                            :class="live_demo_site ? 'active' : ''">
                                            <label :class="select_option == 'individual' ? 'mar_top_18' : ''">Live Demo
                                                Date <span class="star_required">*</span>
                                            </label>
                                            <date-picker v-model="live_demo_site" :disable="datetimeConfig"
                                                :min="minDatetime" v-validate="'required'" type="date"
                                                :auto-submit="true"
                                                v-bind:class="{ 'is-invalid': errors.has('live_demo_site') }"></date-picker>
                                            <input type="hidden" v-validate="'required'"
                                                v-bind:class="{ 'is-invalid': errors.has('live_demo_site') }"
                                                v-model="live_demo_site" name="live_demo_site"
                                                data-vv-as="live demo date" style="display: none !important;" />
                                            <small class="invalid-feedback" v-if="errors.has('live_demo_site')">{{
                                                errors.first('live_demo_site') }}</small>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 signup_fields_multiselect">
                                        <div class="form-group multiselect_dropdown_ui"
                                            v-click-outside="enabledScrollZoneFieldMethod">
                                            <label>Time zone<span class="star_required">*</span></label>
                                            <div @click="disabledScrollZoneFieldMethod">
                                                <multiselect v-model="selectedTimeZone" label="name" track-by="value"
                                                    :options="slotTimeListArr" :option-height="104" :multiple="false"
                                                    v-validate="'required'"
                                                    v-bind:class="{ 'is-invalid': errors.has('selectedTimeZone') }"
                                                    name="selectedTimeZone" data-vv-as="timezone" placeholder=""
                                                    :show-labels="false">
                                                    <span slot="noResult">No elements found.</span>
                                                </multiselect>
                                            </div>
                                            <small class="invalid-feedback d-block"
                                                v-if="errors.has('selectedTimeZone')">The time zone field is
                                                required</small>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 signup_fields_multiselect" v-if="selectedTimeZone">
                                        <div class="form-group multiselect_dropdown_ui"
                                            v-click-outside="enabledScrollSlotFieldMethod">
                                            <label>Live Demo Slot<span class="star_required">*</span></label>
                                            <div @click="disabledScrollSlotFieldMethod">
                                                <multiselect v-model="selectedTimeSlot"
                                                    :options="disabledBookedSlotsMethod(selectedTimeZone.value.time_slots_24hr)"
                                                    :option-height="104" :multiple="false" v-validate="'required'"
                                                    v-bind:class="{ 'is-invalid': errors.has('selectedTimeSlot') }"
                                                    name="selectedTimeSlot" data-vv-as="selectedTimeSlot" placeholder=""
                                                    :show-labels="false">
                                                    <span slot="noResult">No elements found.</span>
                                                </multiselect>
                                            </div>
                                            <small class="invalid-feedback d-block"
                                                v-if="errors.has('selectedTimeSlot')">The slot field is required</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-sm-12">
                                        <button type="submit" class="btn btn-primary register_now_btn"
                                            :disabled="submitted">Register
                                            Now</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="request_for_demo_section_body" v-else style="min-height:390px;">
                            <div class="request_for_demo_confirmation_box">
                                <h5 class="mb-1">Verification is required for the demo request</h5>
                                <p class="blurb_f_email">An OTP has been sent to your email address.</p>
                                <form @submit.prevent="demoForRequestSubmitMethod" class="mt-4">
                                    <div class="form-group">
                                        <label>Enter OTP <span class="star_required">*</span></label>
                                        <input type="text" class="form-control" v-validate="{ required: true, min: 6 }"
                                            v-model="otp" name="otp" v-bind:class="{ 'is-invalid': errors.has('otp') }"
                                            data-vv-as="otp" style="width: 100px;" maxlength="6">
                                        <small class="invalid-feedback" v-if="errors.has('otp')">{{ errors.first('otp')
                                        }}</small>
                                    </div>
                                    <div class="btn-wrp mt-4">
                                        <button class="btn btn-primary register_now_btn"
                                            :disabled="submitted">Verify</button>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col text-left">
                                            <template v-if="countDown == 0">
                                                <span class="resend_otp_txt">
                                                    Didn't receive an OTP? <span @click="resentOTPGenerateMethod">Click
                                                        here <br> to resend OTP</span>
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span class="resend_otp_txt">Resend OTP in {{ displayTimes }} min</span>
                                            </template>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <demo-req-already-scheduled-popup v-if="demoReqAlreadyScheduledPopupState"></demo-req-already-scheduled-popup>
    </div>
</template>

<script>
/*eslint-disable */
var interval;

import 'vue-datetime/dist/vue-datetime.css';
import 'moment-timezone';

import Multiselect from 'vue-multiselect';
import VueDatetimeJs from 'vue-datetime-js';
import { bus } from '@/main';
import countries from '@/services/country.json';
import demoReqAlreadyScheduledPopup from '@/components/public/demo-req-already-scheduled-popup/';
import moment from 'moment';
import toast from '@/services/toast';

export default {
    name: 'request-for-demo-popup',
    components: {
        Multiselect,
        datePicker: VueDatetimeJs,
        'demo-req-already-scheduled-popup': demoReqAlreadyScheduledPopup
    },
    props: [],
    data() {
        return {
            first_name: '',
            last_name: '',
            email: '',
            phone_no: '',
            company_name: '',
            num_of_attendees: '',
            country: '',
            city: '',
            live_demo_site: '',
            submitted: false,
            select_option: 'company',
            minDatetime: this.getTomorrowDate(),
            countryList: [],
            slotTimeList: null,
            slotTimeListArr: [],
            demoReqFormConfirmationState: false,
            selectedTimeZone: '',
            selectedTimeSlot: '',
            selectedTimeSlotIndex: '',
            isClickOutsideEnabledOfC: false,
            isClickOutsideEnabledOfZone: false,
            isClickOutsideEnabledOfSlot: false,
            demoReqFirstScreenState: true,
            otp: '',
            countDown: 600,
            displayTimes: '10:00',
            demoReqAlreadyScheduledPopupState: false,
            datetimeConfig: ['Sunday', 'Saturday'],
            bookedSlots: []
        }
    },
    computed: {
    },
    mounted() {
        Object.keys(countries).map((key, index) => {
            this.countryList.push({
                name: countries[key],
                value: key
            })
        });
        this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
        this.$store.dispatch('getTimeSlotsWithZoneAction').then((res) => {
            this.slotTimeList = res.data.timezones;
            if (!this.slotTimeList) return;
            this.slotTimeListArr = Object.entries(this.slotTimeList).map(([name, value]) => ({ name, value }));
        });
        bus.$on('demoReqAlreadyScheduledPopupStateBus', (data) => {
            this.demoReqAlreadyScheduledPopupState = data;
        });
        this.$store.dispatch('alreadyBookedSlotListAction').then((res) => {
            this.bookedSlots = res.data.data.booked_slots;
        });
    },
    methods: {
        getTomorrowDate() {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            const year = tomorrow.getFullYear();
            const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
            const day = String(tomorrow.getDate()).padStart(2, '0');
            const formattedTomorrow = `${year}-${month}-${day}`;
            return formattedTomorrow;
        },
        disabledBookedSlotsMethod(slots) {
            const timezoneMap = {
                'IST': 'Asia/Kolkata',
                'JST': 'Asia/Tokyo',
                'GMT': 'Europe/London',
                'BST': 'Europe/London',
                'EDT': 'America/New_York',
                'CDT': 'America/Chicago',
                'PDT': 'America/Los_Angeles',
                'CST': 'America/Chicago',
                'ART': 'America/Argentina/Buenos_Aires',
            };

            const targetDate = this.live_demo_site;
            const targetTimezoneAbbr = this.selectedTimeZone.name;

            const targetIANA = timezoneMap[targetTimezoneAbbr] || targetTimezoneAbbr;

            const bookedUTCSeconds = this.bookedSlots.map(slot => {
                const dateTimeString = `${slot.date} ${slot.user_timeslot}`;
                const bookedTimezoneAbbr = slot.user_timezone;
                const bookedIANA = timezoneMap[bookedTimezoneAbbr] || bookedTimezoneAbbr;
                const utcMoment = moment.tz(dateTimeString, 'YYYY-MM-DD HH:mm', bookedIANA);
                return utcMoment.utc().format('YYYY-MM-DD HH:mm');
            });

            const nowUTC = moment.utc();
            const twentyFourHoursFromNowUTC = nowUTC.add(24, 'hours');

            const available_slots = slots.filter(slotTime => {
                const currentDateTimeString = `${targetDate} ${slotTime}`;
                const currentSlotMoment = moment.tz(currentDateTimeString, 'YYYY/MM/DD HH:mm', targetIANA);

                const currentSlotUTCMoment = currentSlotMoment.utc();

                const currentSlotUTCKey = currentSlotUTCMoment.format('YYYY-MM-DD HH:mm');
                const isBooked = bookedUTCSeconds.includes(currentSlotUTCKey);

                const isTooSoon = currentSlotUTCMoment.isSameOrBefore(twentyFourHoursFromNowUTC);

                return !isBooked && !isTooSoon;
            });

            return available_slots;
        },
        countDownTimer() {
            if (this.countDown > 0) {
                interval = setTimeout(() => {
                    this.countDown -= 1;
                    const minutes = Math.floor(this.countDown / 60);
                    const remainingSeconds = this.countDown % 60;
                    this.displayTimes = minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');
                    this.countDownTimer();
                }, 1000);
            }
        },
        backToFirstScreenMethod() {
            var firstSection = document.getElementsByClassName('slide_actv');
            firstSection[0].click();
        },
        scrollBackOfDemoReqMethod() {
            bus.$emit('moveToFirstInSliderBus', true);
        },
        enabledScrollContryFieldMethod() {
            if (this.isClickOutsideEnabledOfC) {
                bus.$emit('movingFlagStateBus', false);
                this.isClickOutsideEnabledOfC = false;
            }
        },
        enabledScrollZoneFieldMethod() {
            if (this.isClickOutsideEnabledOfZone) {
                bus.$emit('movingFlagStateBus', false);
                this.isClickOutsideEnabledOfZone = false;
            }
        },
        enabledScrollSlotFieldMethod() {
            if (this.isClickOutsideEnabledOfSlot) {
                bus.$emit('movingFlagStateBus', false);
                this.isClickOutsideEnabledOfSlot = false;
            }
        },
        disabledScrollContryFieldMethod() {
            bus.$emit('movingFlagStateBus', true);
            this.isClickOutsideEnabledOfC = true;
        },
        disabledScrollZoneFieldMethod() {
            bus.$emit('movingFlagStateBus', true);
            this.isClickOutsideEnabledOfZone = true;
        },
        disabledScrollSlotFieldMethod() {
            bus.$emit('movingFlagStateBus', true);
            this.isClickOutsideEnabledOfSlot = true;
        },
        clearFieldsMethod() {
            this.first_name = '';
            this.last_name = '';
            this.email = '';
            this.phone_no = '';
            this.city = '';
            this.country = '';
            this.live_demo_site = '';
            this.num_of_attendees = '';
            this.company_name = '';
            this.select_option = 'company';
            this.$validator.reset();
            this.selectedTimeSlot = '';
            this.selectedTimeZone = '';
            this.otp = "";
            this.clearTimeOutMethod();
        },
        clearTimeOutMethod() {
            clearInterval(interval);
            this.displayTimes = '10:00';
            this.countDown = 600;
        },
        demoReqFormConfirmationMethod() {
            this.clearFieldsMethod();
            this.demoReqFormConfirmationState = false;
            this.demoReqFirstScreenState = true;

        },
        resentOTPGenerateMethod() {
            let data = {
                email: this.email,
            }
            this.$store.dispatch('otpGenerateForDemoReqAction', data).then((res) => {
                toast.success(res.data.msg || 'Request processed successfully.');
                this.clearTimeOutMethod();
                this.countDownTimer();
            })
        },
        otpGenerateForDemoReqMethod() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.submitted = true
                    let data = {
                        email: this.email,
                    }
                    this.$store.dispatch('otpGenerateForDemoReqAction', data)
                        .then((res) => {
                            this.countDownTimer();
                            this.submitted = false;
                            toast.success(res.data.msg || 'Request processed successfully.');
                            this.demoReqFirstScreenState = false;
                        }).catch((err) => {
                            this.submitted = false;
                            if (err.status === 400) {
                                this.demoReqAlreadyScheduledOpenMethod();
                            }
                        })
                    return;
                }
            })
        },
        demoForRequestSubmitMethod() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.submitted = true
                    let data = {
                        title: this.select_option,
                        fname: this.first_name,
                        lname: this.last_name,
                        otp: this.otp,
                        mobile: this.phone_no,
                        email: this.email,
                        city: this.city,
                        country: this.country.value,
                        date: moment(this.live_demo_site).format('YYYY-MM-DD'),
                        time: this.handleSelect(this.selectedTimeSlot),
                        num_of_attendees: this.num_of_attendees,
                        company_name: this.company_name,
                        timezone: this.selectedTimeZone.name,
                        timeslot: this.selectedTimeSlot
                    }
                    this.$store.dispatch('requestForDemoAction', data)
                        .then((res) => {
                            toast.success(res.data.msg || 'Request processed successfully.');
                            this.submitted = false;
                            this.demoReqFormConfirmationState = true;
                        }).catch((err) => {
                            this.submitted = false
                            toast.error(err.data.user_msg || err.data.msg);
                        })
                    return;
                }
            })
        },
        handleSelect(selectedValue) {
            const localNow = moment();
            const timePart = localNow.format(selectedValue);
            const datePart = moment(this.live_demo_site).format('YYYY-MM-DD');
            const desiredFormatTimestamp = `${datePart} ${timePart}`;
            return desiredFormatTimestamp;
        },
        demoReqAlreadyScheduledOpenMethod() {
            this.demoReqAlreadyScheduledPopupState = true;
            document.body.classList.add('demo_req_already_scheduled_popup');
        }
    },
    watch: {
        country(newVal, oldVal) {
            if (newVal) {
                this.enabledScrollContryFieldMethod();
            }
        },
        selectedTimeZone(newVal, oldVal) {
            if (newVal) {
                this.enabledScrollZoneFieldMethod();
            }
        },
        selectedTimeSlot(newVal, oldVal) {
            if (newVal) {
                this.enabledScrollSlotFieldMethod();
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.request_for_demo_section {
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    padding: 15px 0;
    min-height: 100dvh;
    display: table;
    width: 100%;

    .request_for_demo_section_inner {
        display: table-cell;
        vertical-align: middle;
    }

    .request_for_demo_section_modal {
        background: rgba(0, 0, 0, 0.8);
        max-width: 840px;
        margin: 0 auto;
        border-radius: 5px;
        -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        position: relative;
    }

    .request_for_demo_section_header {
        padding: 15px 20px;
        position: relative;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        h4 {
            font-size: 30px;
            letter-spacing: 0;
            margin-bottom: 0;
            color: #ffd400;
            font-family: 'origin_tech_demoregular';

            @media only screen and (max-width:767px) {
                font-size: 26px;
            }
        }

        .request_for_demo_blurb {
            font-size: 16px;
            color: #fff;
            margin: 0;
            line-height: 1.3;
            text-align: justify;
        }
    }

    .request_for_demo_section_body {
        padding: 20px;
        position: relative;

        // max-height: calc(100dvh - 250px);
        // overflow-y: auto;
        &::-webkit-scrollbar {
            width: 4px;
            background: #00000016;
        }

        &::-moz-scrollbar {
            width: 4px;
            background: #00000016;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #232323;
        }

        &::-moz-scrollbar-thumb {
            background-color: #232323;
        }

        .fa-times-circle-o {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 35px;
            color: #e4002b;
            z-index: 10;
            cursor: pointer;

            &:hover {
                color: #ffd400;
            }
        }

        label {
            font-size: 17px;
            margin-bottom: 4px;
            color: #ffd400;

            // &.mar_top_18{margin-top:18px;}
            @media only screen and (max-width:767px) {
                margin-top: 0px !important;
            }
        }

        .form-group {
            margin-bottom: 10px;
        }

        .form-control {
            width: 100%;
            height: 44px;
            font-weight: normal;
            font-size: 16px;
            border-radius: 5px;
            padding: 0 20px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: none;
            outline: none !important;
            box-shadow: none !important;
            color: #ffd400;
            background: rgba(255, 255, 255, 0.08);

            &:focus,
            &.active {
                border: 1px solid #ffd400;
            }

            &::placeholder,
            &::-webkit-input-placeholder,
            &::-moz-placeholder {
                color: rgba(255, 255, 255, 0.3);
            }

            &:focus::-webkit-input-placeholder {
                font-size: 0;
            }

            &:focus::-moz-placeholder {
                font-size: 0;
            }

            &.custom_style_of_datetime {
                background: none;
                padding: 0px;
                border: none;
            }

            option {
                color: black;
            }
        }

        .invalid-feedback {
            font-size: 14px;
            line-height: 1;
            color: #ff2400;
        }

        .register_now_btn {
            background: none;
            border: 2px solid #ffe400;
            color: #ffe400;
            text-transform: uppercase;
            font-size: 28px;
            padding: 8px 20px;
            line-height: 1;
            height: auto;
            border-radius: 6px;
            box-shadow: none !important;
            outline: none !important;
            font-family: 'ACETONE';
            line-height: 1;

            &:hover {
                background: #ffe400;
                color: #000000;
            }
        }
    }

    .custom_radio_btn_for_demo {

        [type="radio"]:checked,
        [type="radio"]:not(:checked) {
            position: absolute;
            left: -9999px;
        }

        [type="radio"]:checked+label,
        [type="radio"]:not(:checked)+label {
            position: relative;
            padding-left: 28px;
            cursor: pointer;
            line-height: 20px;
            display: inline-block;
            color: #ffd400;
        }

        [type="radio"]:checked+label:before,
        [type="radio"]:not(:checked)+label:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 20px;
            height: 20px;
            border: 3px solid #ffd400;
            border-radius: 100%;
            // background: #fff;
        }

        [type="radio"]:checked+label:after,
        [type="radio"]:not(:checked)+label:after {
            content: '';
            width: 12px;
            height: 12px;
            background: #ffd400;
            position: absolute;
            top: 4px;
            left: 4px;
            border-radius: 100%;
            -webkit-transition: all 0.2s ease;
            transition: all 0.2s ease;
        }

        [type="radio"]:not(:checked)+label:after {
            opacity: 0;
            -webkit-transform: scale(0);
            transform: scale(0);
        }

        [type="radio"]:checked+label:after {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1);
        }
    }

    .font_style_change {
        select.form-control {
            font-size: 0px !important;

            option {
                font-size: 18px !important;
            }
        }
    }

    .request_for_demo_confirmation_box {
        h5 {
            color: #fff;
            font-size: 28px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            margin-bottom: 30px;
            text-align: justify;
            font-weight: normal;
            line-height: 1.3;
        }

        h4 {
            color: #fff;
            font-size: 22px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            margin-bottom: 50px;
            text-align: justify;
            font-weight: normal;
            line-height: 1.3;
        }
    }
}

.blurb_f_email {
    font-size: 16px;
    color: #fff;
    margin: 0;
    line-height: 1.3;
    text-align: justify;
}

.resend_otp_txt {
    color: #00ff60;
    font-size: 16px;
    font-family: Arial, Helvetica, sans-serif;

    span {
        cursor: pointer;

        &:hover {
            color: #ffe400;
        }
    }

    a {
        color: #00ff60 !important;
        text-decoration: none;

        &:hover {
            color: #ffe400 !important
        }
    }
}

@media only screen and (max-width:1360px) and (min-width:768px) {
    .request_for_demo_section {
        .register_now_btn {
            font-size: 22px !important;
        }

        .request_for_demo_section_header {
            h4 {
                font-size: 26px !important;
            }

            .request_for_demo_blurb {
                font-size: 14px !important;
            }
        }
    }
}

@media only screen and (max-width:1290px) and (min-width:1260px) and (max-height:699px) {
    .request_for_demo_section {
        .register_now_btn {
            font-size: 18px !important;
        }

        .request_for_demo_section_header {
            padding: 20px 20px 10px;

            h4 {
                font-size: 22px !important;
            }

            .request_for_demo_blurb {
                font-size: 14px !important;
            }
        }

        .request_for_demo_section_body {
            padding: 10px 15px;

            label {
                font-size: 15px;
            }

            .form-control {
                height: 40px;
            }
        }
    }
}
</style>